export default "__VITE_ASSET__Cf5gd0nw__"